import { render } from "./ResetPassword.vue?vue&type=template&id=d645b676&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=d645b676&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d645b676"

export default script